import script from "./vendor_list.vue?vue&type=script&setup=true&lang=js"
export * from "./vendor_list.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__